<div class="table-header-actions">
  <ng-content></ng-content>
  <i nz-icon nzType="export" nzTheme="outline" class="export-btn" (click)="exportBtnClicked.emit()" *ngIf="withExportOption"></i>
  <i nz-icon nzType="sync" nzTheme="outline" class="sync-btn {{ loading ? 'sync-btn--loading' : '' }}" (click)="reload.emit()"></i>
</div>
